<template>
<!--  订单提货-->
  <div id="myOrderDelivery">
    <div style="width: 100%;height: 100%;margin-top: 32px;padding-bottom: 40px">
      <allMallSerch style="border-bottom: 1px solid #e6e6e6"></allMallSerch>
      <div style="width: 1300px; margin: auto;padding-top: 20px">
        <div style="background-color: #fce6e7;border: 1px solid #eee;border-bottom: none;" class="font18 p_10">订单编号：{{ orderNum }}</div>
        <div style="height: 600px;border: 1px solid #eee;border-top: none;display: flex;align-items: center;justify-content: center">
          <div>
            <div class="t_c"><span>支付金额：</span> <span class="colorRed font32">￥{{ totalMoney }}</span></div>
            <div class="p_r" style="margin-top: 15%;height: 300px">
              <div v-if="payStatus" style="position: absolute;left: 0;top: 0;bottom: 0;right: 0;">
                <div style="position: absolute;left: 0;top: 0;bottom: 0;right: 0;background-color: #fff;opacity: 0.5">
                </div>
                <div style="display: flex;width: 100%;height: 100%;align-items: center;justify-content: center;position: relative;z-index: 2">
                  <img src="../../../../assets/paySuccess.png" height="80" width="80"/>
                </div>
              </div>
              <div v-show="!payStatus" style="width: 300px;height: 300px" id="qrcode">

              </div>
            </div>
            <div v-if="!payStatus" style="margin-top: 5%" class="t_c font18">扫码支付</div>
            <div v-if="payStatus" class="t_c"><span>支付成功 </span><span class="font42 f_w colorYellow"> {{ count }} </span><span> 秒后 </span><span @click="$router.push('/')" class="c_p f_w">返回首页</span></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import Index from '../../myIndex/index'
let countInter
console.log(countInter)
export default {
  name: 'myOrderDelivery',
  data () {
    return {
      count: 5,
      timeInter: '',
      payStatus: false,
      orderNum: this.$route.query.orderNum,
      payWay: this.$route.query.payWay,
      totalMoney: this.$route.query.totalMoney,
      payType: this.$route.query.payType,
      orderPayType: this.$route.query.orderPayType
    }
  },
  destroyed () {
    clearInterval(this.timeInter)
  },
  created () {
    document.title = '百钢商城 | 钢铁电商，百炼成钢'
    if (this.orderNum && this.totalMoney && this.payWay) {
      this.geterweima()
    }
  },
  methods: {
    countBack () {
      this.count = 5
      countInter = setInterval(p => {
        this.count--
        if (this.count === 0) {
          this.$router.push('/')
        }
      }, 1000)
    },
    getOrderDetail () {
      this.$axiox.get('/baigang/shop/app/order/queryPayResult/' + (this.$route.query.orderPayType ? 1 : 0) + '/' + this.orderNum).then(p => {
        this.payStatus = p.data
        if (this.payStatus) {
          this.countBack()
          clearInterval(this.timeInter)
        }
      })
    },
    geterweima () {
      let payData = {
        channel: this.payWay === 'aliPay' ? 2 : 1,
        orderPayType: this.orderPayType ? 2 : 1,
        outTradeNo: this.orderNum,
        tradeType: 'NATIVE',
        uniPayStatus: this.payType ? 0 : 1,
        wxPayMethod: 1
      }
      this.$axiox.post('/baigang/app/wx/pay/unifiedOrder/1/' + (this.payWay === 'aliPay' ? 2 : 1), payData).then(p => {
        if (p.data.code_url) {
          let qrcode = new QRCode('qrcode', {
            width: 300,
            height: 300,
            text: p.data.code_url, // 二维码地址
            colorDark: '#000',
            colorLight: '#fff'
          })
          this.timeInter = setInterval(p => {
            this.getOrderDetail()
          }, 1000)
          console.log(qrcode)
        }
      })
    }
  },
  computed: {
  },
  components: {Index}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/page/mySteelMall/orderPayConfirm.vue